import { useMatch } from "react-router";
import { AuthInnerRoutes } from "../types";

// Auth pages that establish their own session out-of-band (a bff-issued opaque invite
// token, exchanged for a real Firebase session by signing in directly) and drive their
// own post-landing navigation once that completes. The generic auth-redirect logic
// (useAuth's null-user redirect-to-signin, useAuthRedirection's verify/noCompany/"go to
// app" redirects) must not interfere with these while they're still mid-flow: there's no
// session yet when the user first lands on accept-invite, and complete-profile needs to
// finish collecting name/role before the app's normal "you're all set, go to the
// dashboard" redirect kicks in.
const SELF_MANAGED_AUTH_ROUTES: AuthInnerRoutes[] = [
  "accept-invite",
  "complete-profile",
];

export const useIsSelfManagedAuthRoute = () => {
  const match = useMatch("/auth/:innerRoute");
  return SELF_MANAGED_AUTH_ROUTES.includes(
    match?.params.innerRoute as AuthInnerRoutes,
  );
};
